module.exports = __webpack_public_path__ + "static/media/photo302.ecded24e.jpg";